export const LIST_CUSTOMER_LOAN = 'LIST_CUSTOMER_LOAN';
export const STORE_CUSTOMER_LOAN = 'STORE_CUSTOMER_LOAN';
export const SAVE_CUSTOMER_LOAN = 'SAVE_CUSTOMER_LOAN';